<template>
  <BCard>
    <div class="flex w-full justify-between items-center">
      <div class="flex gap-[12px]">
        <BButton
          variant="primary"
          size="sm"
          class="rounded-[6px]"
          @click="$router.back()"
        >
          <span class="k-arrow-left-2" />
        </BButton>
        <div class="text-[#333333] font-semibold text-[24px]">
          Detail Partner
        </div>
      </div>
      <BButton
        variant="primary"
        size="md"
        class="rounded-[6px]"
        @click="syncTransaction"
      >
        <div class="flex gap-[5px] items-center">
          <span class="k-clock-1" />
          <div>
            Riwayat Sync
          </div>
        </div>
      </BButton>
    </div>
    <hr class="my-1">
    <div class="flex flex-col md:flex-row items-start gap-[20px]">
      <div class="border gap-[12px] text-[#333333] rounded-xl">
        <div class="flex items-center gap-7 px-1 pt-1">
          <img
            :src="user.badge_level ? user.badge_level : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/user.svg'"
            alt="human"
            width="25"
          >
          <div>
            <div class="font-semibold capitalize">
              {{ user.name.toLowerCase() }}
            </div>
            <div class="underline">
              {{ user.email }}
            </div>
            <div>
              Tgl Bergabung: {{ DDMMYYYY(user.joined_date) }}
            </div>
          </div>
        </div>
        <div class="bg-[#F8F8F8] rounded-lg mt-1 p-[8px]">
          <div class="text-[#626262] font-medium">
            Total Cards : {{ user.total_card }} Cards
          </div>
        </div>
      </div>
      <div v-if="user.organization">
        <!-- Main Label -->
        <div
          id="tooltip-main-account"
          class="bg-[#F3F4F6] text-[#333333] px-[16px] py-[8px] rounded-full font-medium text-[14px] cursor-pointer inline-block mt-2 md:mt-0 break-all"
        >
          Organisasi : {{ user.organization.name }}
        </div>

        <!-- Tooltip Component -->
        <b-tooltip
          v-if="user.organization.main_account"
          target="tooltip-main-account"
          triggers="hover"
          placement="top"
          variant="primary"
          custom-class="tooltip-auto-width"
        >
          <div class="text-left flex flex-column gap-1">
            <span class="text-[#333333] font-semibold text-[14px]">Main Account</span>
            <span class="text-[#828282] text-[13px]">{{ user.organization.main_account }}</span>
          </div>
        </b-tooltip>
      </div>
    </div>
    <BTabs
      v-model="tabIndex"
      class="mt-2"
      pills
      active-nav-item-class="rounded-pill"
      nav-class="mb-0"
    >
      <BTab
        title="General"
        active
        lazy
        title-item-class="bg-[#F8F8F8] mr-[24px] mb-[1rem] rounded-[25px]"
      >
        <Information />
      </BTab>
      <BTab
        :active="$route.query.tab === 'cards'"
        lazy
        title-item-class="bg-[#F8F8F8] mr-[24px] mb-[1rem] rounded-[25px]"
        title="Kartu"
      >
        <Cards />
      </BTab>
    </BTabs>
  </BCard>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { DDMMYYYY } from '@/libs/filterDate'
import Cards from './Cards.vue'
import Information from './General/Index.vue'

export default {
  components: {
    Cards,
    Information,
  },
  data() {
    return {
      DDMMYYYY,
      tabs: ['general', 'cards'],
      tabIndex: 0,
      user: null,
    }
  },
  watch: {
    tabIndex(newTab) {
      const tab = this.tabs[newTab]
      if (this.$route.query.tab !== tab) this.$router.replace({ query: { tab } })
    },
  },
  mounted() {
    this.getUser()
  },
  methods: {
    async getUser() {
      const { id } = this.$route.params
      const url = `auth/api/v1/admin/user/${id}/info`

      try {
        const data = await newAxiosIns.request({
          method: 'get',
          url,
        })

        this.user = data.data.data
      } catch {
        this.$toast_error({ message: 'Gagal load data user' })
      }
    },
    syncTransaction() {
      this.$router.push(
        `/komcards-data-partner/sync-transaction/${this.$route.params.id}`,
      )
    },
  },
}
</script>

<style>
.tooltip-auto-width .tooltip-inner {
  max-width: none;
  white-space: nowrap;
}
</style>
